<script setup>
  import {nextTick, ref, watch} from "vue";

  import ComponentDialog from "@components/Dialogs/Dialog.vue";
  import ComponentTodoList from "@components/Lists/TodoList.vue";
  import {router} from "@inertiajs/vue3";
  import {MedButton, MedSpinner} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentPatientTodosDialog",
  });

  const props = defineProps({
    patients: {
      type: Object,
      default: () => ({}),
    },
  });

  const refDialog = ref(null);
  const currentPatient = ref(null);
  const processing = ref(false);

  watch(
    () => props.patients,
    (patients) => {
      if (currentPatient.value) {
        currentPatient.value = patients.data.find((patient) => patient.id === currentPatient.value.id);
      }
    },
  );

  function open(patient) {
    processing.value = true;
    currentPatient.value = patient;
    refDialog.value.open();

    // because the following router.reload() only reloads the current
    // url and does not allow to append a get parameter, we have to
    // inject the withTodos parameter manually. this parameter
    // will include all to-do items for this single patient.
    let url = new URL(globalThis.location.href);
    url.searchParams.set("withTodos", patient.id);
    history.pushState({}, "", url);

    router.reload({
      only: ["patients"],
      preserveState: true,
      preserveScroll: true,
      onSuccess: () => {
        nextTick(() => {
          processing.value = false;
        });
      },
      onError: () => {
        processing.value = false;
        close();
      },
    });
  }

  function close() {
    refDialog.value.close();
  }

  defineExpose({
    open,
    close,
  });
</script>

<template>
  <ComponentDialog ref="refDialog" dialog-width="small" :test-id="getTestId('patient-todo')">
    <template #title>
      Aufgaben für
      <span :data-encrypted="currentPatient.firstname" />
      <span :data-encrypted="currentPatient.lastname" />
    </template>

    <template #content>
      <div v-if="processing" class="flex justify-center">
        <MedSpinner size="xl" :data-test="getTestId('patient-todo-dialog-spinner')" />
      </div>

      <ComponentTodoList v-else :patient="currentPatient" :layer="true" :test-id="getTestId('patient-todo-dialog')" />
    </template>

    <template #actions>
      <MedButton :data-test="getTestId('patient-todo-dialog-close-button')" @click="close()">Schließen</MedButton>
    </template>
  </ComponentDialog>
</template>
